$(() => {
  $('.section-simulation').each(function() {
    const $this_section = $(this)
    const $block = $this_section.find('.simulation-block')

    $block.on('click', function(e) {
      e.preventDefault()
      const $this = $(this)

      if(!($(e.target).parents('.dropdown').length && $this.hasClass('simulation-block--selected'))) {
        $this.toggleClass('simulation-block--selected')
        $this_section.trigger('update-block')
      }
    })

    $block.find('.dropdown-menu .dropdown-item').on('click', function(e) {
      e.preventDefault()
      const $this = $(this)
      const $button = $this.parents('.dropdown').find('.btn-select span')
      const $price = $this.parents('.simulation-block').find('.price')

      $button.text($this.text())
      $price.text($this.data('value'))
      $this_section.trigger('update-block')
    })

    $this_section.on('update-block', function() {
      const $this = $(this)
      const $result_box = $('.section-simulation__calc')
      const select_item_list = [];
      const select_price_list = []

      $this.find('.simulation-block--selected').each(function() {
        const $this = $(this)
        select_item_list.push(
          $this.find('.simulation-block__title span').text() +
          ' ' +
          $this.find('.dropdown .btn-select span').text()
        )
        select_price_list.push(Number($this.find('.price').text().replace(',', '')))
      })

      const total_price = select_price_list.reduce((previousValue,currentValue) => previousValue + currentValue, 0)

      $result_box.find('.price').text(total_price.toLocaleString())
      $result_box.find('.price-tax').text((total_price*1.1).toLocaleString())

      console.log($this_section.find('input[name="金額"]'))

      $this_section.find('input[name="希望のメニュー"]').val(select_item_list)
      $this_section.find('input[name="金額"]').val((total_price*1.1).toLocaleString())
      
    })
  })
})